module.exports = __webpack_public_path__ + "static/about-com-f0fd9e5c619306bbf3e30ad716d72373.jpg";